import type { LaborDepartureSnapshot } from "@/lib/labor/laborDepartureSnapshot";

const END_SESSION_PATH = "/api/labor/end-session";

/**
 * Best-effort labor clock-out while the document is unloading (tab close, browser quit,
 * navigate to another origin). Uses `fetch` with `keepalive` so the request can outlive the page.
 */
export function sendLaborDepartureEndBeacon(snapshot: LaborDepartureSnapshot): void {
  if (typeof fetch !== "function") {
    return;
  }
  const body = JSON.stringify({
    sessionId: snapshot.sessionId,
    idleTimeout: false,
    domain: snapshot.domain,
  });
  try {
    void fetch(END_SESSION_PATH, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${snapshot.accessToken}`,
      },
      body,
      keepalive: true,
    });
  } catch {
    /* page may already be torn down */
  }
}
